import TrendDurationPicker from './TrendDurationPicker';

const TrendFilters = ({ duration, setDuration, disabled }) => {
  return (
    <div className='flex items-center'>
      <TrendDurationPicker
        value={duration}
        onChange={setDuration}
        disabled={disabled}
      />
    </div>
  );
};

export default TrendFilters;
